import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import db from "../../../../db"
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import FormDialogView from "../FormDialogView/FormDialogView"
import FormDialogCancel from "../FormDialogCancel/FormDialogCancel"
import { toast } from 'react-toastify';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import FindInPageIcon from '@material-ui/icons/FindInPage';
import CancelIcon from '@material-ui/icons/Cancel';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const DataTable = props => {
  const { className, ...rest } = props;
  const [data, setData] = useState([])
  const [opView, setOpView] = useState(false);
  const [opCancel, setOpCancel] = useState(false);
  const [orderNumber, setOrderNumber] = useState()
  const [orderDate, setOrderDate] = useState()
  const [customer, setCustomer] = useState()
  const [customerData, setCustomerData] = useState([])
  const [deadline, setDeadline] = useState(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate())
  const [shortCode, setShortCode] = useState()
  const [shortCodeData, setShortCodeData] = useState([])
  const [model, setModel] = useState("")
  const [country, setCountry] = useState("")
  const [sizes, setSizes] = useState([])
  const [startOrders, setStartOrders] = useState([])
  const [finalOrders, setFinalOrders] = useState([])
  const [canceledOrders, setCanceledOrders] = useState([])
  const [keyId, setKeyId] = useState([])

  const fields =
  {
    keyId: {
      value: keyId,
      func: setKeyId
    },
    orderNumber: {
      value: orderNumber,
      func: setOrderNumber
    },
    orderDate: {
      value: orderDate,
      func: setOrderDate
    },
    customer: {
      value: customer,
      func: setCustomer,
      data: customerData
    },
    deadline: {
      value: deadline,
      func: setDeadline
    },
    orderDate: {
      value: orderDate,
      func: setOrderDate
    },
    shortCode: {
      value: shortCode,
      func: setShortCode,
      data: shortCodeData
    },
    model: {
      value: model,
      func: setModel
    },
    country: {
      value: country,
      func: setCountry
    },
    sizes: {
      value: sizes,
      func: setSizes
    },
    startOrders: {
      value: startOrders,
      func: setStartOrders
    },
    finalOrders: {
      value: finalOrders,
      func: setFinalOrders
    },
    canceledOrders: {
      value: canceledOrders,
      func: setCanceledOrders
    }
  }

  useEffect(() => {
    db.ref('Orders').on('value', snap => {
      if (snap.val()) {
        const dt = snap.val()
        let sum = 0
        let cancelSum = 0
        Object.keys(dt).map((el, ind) => {
          Object.keys(dt[el].startOrders).map(i => {
            sum += parseInt(dt[el].startOrders[i].sum)
          })
          dt[el].allSum = sum
          sum = 0

          if (dt[el].canceledOrders) {
            dt[el].canceledOrders.map(i => {
              Object.keys(i).map(el => {
                cancelSum += parseInt(i[el].sum)
              })
            })
          }
          dt[el].cancelSum = cancelSum
          cancelSum = 0

        })
        setData(dt)
      }
    })
  }, [])

  const handleView = (i) => {
    setOpView(true)
    setKeyId(i)
    setOrderNumber(data[i].orderNumber)
    setCustomer(data[i].customer)
    setDeadline(data[i].deadline)
    setModel(data[i].model)
    setCountry(data[i].country)
    setShortCode(data[i].shortCode)
    setStartOrders(data[i].startOrders)
    setFinalOrders(data[i].finalOrders)
    setCanceledOrders(data[i].canceledOrders)
    setOrderDate(data[i].orderDate)
    let szStandart
    db.ref('Product').limitToFirst(1).orderByChild("modelCode").equalTo(data[i].shortCode).once('value', snap => {
      for (const key in snap.val()) {
        szStandart = snap.val()[key].sizeStandart
        db.ref('InfoCenter/Sizes').limitToFirst(1).orderByChild("code").equalTo(szStandart).once('value', snap => {
          for (const key in snap.val()) {
            fields.sizes.func(snap.val()[key])
          }
        })
      }
    })


  }

  const handleCancel = (i) => {
    setOpCancel(true)
    setKeyId(i)
    setOrderNumber(data[i].orderNumber)
    setCustomer(data[i].customer)
    setDeadline(data[i].deadline)
    setModel(data[i].model)
    setCountry(data[i].country)
    setShortCode(data[i].shortCode)
    setStartOrders(data[i].startOrders)
    setFinalOrders(data[i].finalOrders)
    let szStandart
    db.ref('Product').limitToFirst(1).orderByChild("modelCode").equalTo(data[i].shortCode).once('value', snap => {
      for (const key in snap.val()) {
        szStandart = snap.val()[key].sizeStandart
        db.ref('InfoCenter/Sizes').limitToFirst(1).orderByChild("code").equalTo(szStandart).once('value', snap => {
          for (const key in snap.val()) {
            fields.sizes.func(snap.val()[key])
          }
        })
      }
    })
  }
  const handleEdit = (keyId) => {
    // setId(keyId)
    // setCode(data[keyId].code)
    // setName(data[keyId].name)
    // setCountry(data[keyId].country)
    // setType(data[keyId].type)
    // setOpChange(true)
  }

  const handleSaveEdit = () => {
    // if (!code || !name || !country || !type) {
    //   toast.error('Լրացրեք բոլոր դաշտերը')
    //   return
    // }
    // if (id) {
    //   db.ref('Partners/' + id).set({
    //     code: code,
    //     name: name,
    //     country: country,
    //     type: type
    //   }).then(() => {
    //     toast.success('Փոփոխված է')
    //     setOpChange(false)
    //     setCode()
    //     setName()
    //     setCountry()
    //     setType()
    //   })
    // }
    // setId()
  }

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Ամսաթիվ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Պատվերի N</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Պատվիրատու</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Մոդել</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Կարճ կոդ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Պատվերի սկզբնական քանակ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Չեղարկված քանակ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Վերջնական պատվեր</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Կատարված քանակ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Կատարման տոկոս</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Պատվերի մնացորդ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Հաջորդ բարձվող քանակ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Կատարման ենթակա</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Կատարման ամսաթիվ</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}>Պատվերի ստատուս</TableCell>
                  <TableCell style={{ "padding": "3px", "fontSize": "10px" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(data).map(i => (
                  < TableRow
                    className={classes.tableRow}
                    hover
                    key={i}
                  >
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}>
                      {data[i].orderDate}
                    </TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}>
                      {data[i].orderNumber}
                    </TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}>
                      {data[i].customer}
                    </TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}>
                      {data[i].model}
                    </TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}>
                      {data[i].shortCode}
                    </TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}> {data[i].allSum}</TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}> {data[i].cancelSum}</TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}>{data[i].allSum - data[i].cancelSum} </TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}></TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}></TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}></TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}></TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}></TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}> {data[i].deadline}</TableCell>
                    <TableCell style={{ "padding": "5px", "fontSize": "10px" }}></TableCell>
                    <TableCell>
                      <IconButton color="primary" onClick={() => handleView(i)} style={{ "padding": "0" }}>
                        <FindInPageIcon />
                      </IconButton>
                      <IconButton color="primary" onClick={() => handleEdit(i)} style={{ "padding": "0" }}>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="primary" size="small" onClick={() => handleCancel(i)} style={{ "padding": "0" }}>
                        <CancelIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <FormDialogView op={opView} setOp={setOpView} title="Դիտել պատվերը" func={handleView} fields={data[keyId]} sizes={sizes} />
      <FormDialogCancel op={opCancel} setOp={setOpCancel} title="Չեղարկել պատվերը" func={handleView} fields={fields} />

    </Card>

  );
};

DataTable.propTypes = {
  className: PropTypes.string
};

export default DataTable;
